import { call, put, takeLatest, select } from 'redux-saga/effects'
import actionTypes from '../../actions/actionTypes'
import { displaySelectionOrderSelector, removeItemfromArray, selectionsDisplayUpdateOrder } from './helpers'
import getData from '../../functions/getData'
import { PROGRAM_SELECTIONSDISPLAY_ITEMS, PROGRAM_SELECTIONS_ITEMS } from '../../constants/state'


const selectionIDSelector = (state, displaySelectionId) => getData(state, [PROGRAM_SELECTIONSDISPLAY_ITEMS, displaySelectionId, 'selectionPk'])


const collectionsSelector = (state, selectionId) => getData(state, [PROGRAM_SELECTIONS_ITEMS, selectionId, 'collections'])

function* deleteCollectionItem(pk) {
    yield put({
        type: actionTypes.ITEMCOLLECTIONS_DELETE_ITEM,
        meta: {},
        payload: {
            pk: pk
        }
    })
}

function* deleteSelectionItem(pk) {
    yield put({
        type: actionTypes.ITEMSELECTIONS_DELETE_ITEM,
        meta: {},
        payload: {
            pk: pk
        }
    })
}

function* deleteSelectionDisplayItem(pk) {
    yield put({
        type: actionTypes.ITEMSELECTIONSDISPLAY_DELETE_ITEM,
        meta: {},
        payload: {
            pk: pk
        }
    })
}

function * deleteItem(data) {
    const pk = yield data.payload.pk
    const oldOrder = yield select(displaySelectionOrderSelector)
    const newOrder = yield removeItemfromArray(oldOrder, pk)
    
    if(false != newOrder) {
        const selectionId = yield select(selectionIDSelector, pk)
        const collections = yield select(collectionsSelector, selectionId)

        yield call(selectionsDisplayUpdateOrder, newOrder.toJS())
        yield call(deleteSelectionDisplayItem, pk)
        yield call(deleteSelectionItem, selectionId)

        yield collections.toJS().map(collectionID => call(deleteCollectionItem, collectionID))
    }
}

function* watchDeleteDisplaySelection() {
    try {
        yield takeLatest(actionTypes.ITEMSELECTIONSDISPLAY_REQUEST_DELETE_ITEM, deleteItem)
    } catch(e) {
        // ToDo: general error
        console.log('error!!!!!', e.message)
    }
}


export default watchDeleteDisplaySelection;